module.exports = __webpack_public_path__ + "assets/img/clock.ef5db451.svg";